import React from 'react';

import blogposts from '../assets/blogposts.js';
import ContentContainer from '../components/ContentContainer.js';
import SiteContainer from '../components/SiteContainer.js';
import PostHtml from '../components/PostHtml.js';
import { findPostBySlug } from '../utils/slug.js';

// The `:url` param arrives exactly as the browser wrote it into the address bar,
// because App.js drives the router with history@5, which does not decode
// `location.pathname`. Comparing it to a stored slug with `===` therefore fails for
// any slug the browser rewrites — which is what hid the `(müller et al 2014)` post.
// findPostBySlug does the tolerant comparison; see src/utils/slug.js.
const BlogPostScreen = (props) => {
  const blogpost = findPostBySlug(blogposts, props.match.params.url);

  return (
    <SiteContainer>
      <ContentContainer>
        {blogpost ? (
          <>
            <h3><strong>{blogpost.title}</strong></h3>
            <p>{blogpost.date}</p>
            <PostHtml html={blogpost.html} />
          </>
        ) : (
          <>
            <h3><strong>Post not found</strong></h3>
            <p>No post lives at this address. <a href="/writing">See everything I've written.</a></p>
          </>
        )}
      </ContentContainer>
    </SiteContainer>
  );
};

export default BlogPostScreen;
